const TimelineEventConstants = require('../constants/timeline/events');
module.exports = {
    getDisplayName: function(key) {
        return TimelineEventConstants[key] ? TimelineEventConstants[key].displayName : key;
    }
}
